export function getOptimizedImageUrl(url: string | null | undefined, width: number = 800, quality: number = 80): string {
  if (!url) return '';
  
  // Handle Supabase images
  if (url.includes('.supabase.co/storage/v1/object/public/')) {
    return url.replace('/object/public/', '/render/image/public/') + `?width=${width}&resize=contain&quality=${quality}`;
  }
  
  // Handle Unsplash images
  if (url.includes('images.unsplash.com')) {
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set('w', width.toString());
      urlObj.searchParams.set('q', quality.toString());
      urlObj.searchParams.set('auto', 'format');
      return urlObj.toString();
    } catch {
      return url;
    }
  }
  
  return url;
}
